export default __webpack_public_path__ + "a23b9076b12162b45be681c696c8d18e.svg";